import baseAPI from "@/http";

const router = "api/relatorio";

export const reportAPI = {
  get: (id) => baseAPI.get(`${router}` + "/get-by-id" + `/${id}`),
  create: (report) => baseAPI.post(router, report),
  update: (report) => baseAPI.put(router, report),
  list: () => baseAPI.get(router),
  getByCity: (id) => baseAPI.get(`${router}` + "/get-by-municipio" + `/${id}`),
  getByPaymentProcess: (id) =>
    baseAPI.get(`${router}` + "/get-by-processo-pagamento" + `/${id}`),
  getByUser: (id, contratoId, tipoSolucaoId) =>
    baseAPI.get(
      `${router}` + "/get-by-usuario" + `/${id}/${contratoId}/${tipoSolucaoId}`
    ),
  getByFilter: (filter) => baseAPI.post(`${router}/get-by-filtro`, filter),
  getByFilterNovo: (filter) =>
    baseAPI.post(`${router}/get-by-filtro-novo`, filter),
  analyse: (report) => baseAPI.put(`${router}` + "/analisar-relatorio", report),
  getReport: (filter) =>
    baseAPI.post(`${router}` + "/relatorio-mensal", filter, {
      responseType: "blob",
    }),
  getReportGlobal: (filter) =>
    baseAPI.post(`${router}` + "/relatorio-global", filter, {
      responseType: "blob",
    }),
  getReportGeral: (filter) =>
    baseAPI.post(`${router}` + "/novo-relatorio-global", filter, {
      responseType: "blob",
    }),
  sendMail: (filter) => baseAPI.post(`${router}` + "/send-mail-report", filter),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  reenviarPesquisa: (relatoriosId) =>
    baseAPI.get(`${router}` + "/envio-pesquisa" + `/${relatoriosId}`),
  downloadAnexo: (relatorioAnexoId) =>
    baseAPI.post("api/arquivo/anexo/download/" + relatorioAnexoId, null, {
      responseType: "blob",
    }),
  downloadRelatorioFinal: (municipioId) =>
    baseAPI.post(
      router + "/relatorio-municipio-pontuacao/" + municipioId,
      null,
      { responseType: "blob" }
    ),
  getRelatorioAnexos: (relatorioId) =>
    baseAPI.get(
      `api/arquivo/anexo/relatorioanexo-por-relatorioid/${relatorioId}`
    ),
  analisarRascunhoIa: (payload, anexos) => {
    const formData = new FormData();
    Object.keys(payload || {}).forEach((chave) => {
      const valor = payload[chave];
      if (valor !== null && valor !== undefined) {
        formData.append(chave, valor);
      }
    });
    (anexos || []).forEach((arquivo) => {
      formData.append("anexos", arquivo, arquivo.name);
    });
    return baseAPI.post("api/IaAnaliseRelatorios/rascunho", formData, {
      timeout: 180000,
    });
  },
};
